import {useState} from "react";
import {postToApi} from "../../api/auth";

export default function AddNoteFolder({onSubmit}) {
    const [value, setValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!value.trim()) { setError("Folder name cannot be empty."); return; }
        setLoading(true);
        setError("");
        try {
            const res = await postToApi("api/notes", {folder: value.trim()});
            if (res.status !== 200) throw new Error(res.msg || "Failed");
            setValue("");
            onSubmit?.(res);
        } catch (err) {
            setError(err.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="row g-2 align-items-end">
            <div className="col-md-9">
                <label className="form-label small fw-medium">New folder</label>
                <input
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    placeholder="Folder name..."
                    value={value}
                    onChange={e => { setValue(e.target.value); setError(""); }}
                    disabled={loading}
                />
                {error && <div className="invalid-feedback">{error}</div>}
            </div>
            <div className="col-md-3">
                <button type="submit" className="btn btn-dark w-100" disabled={loading}>
                    <i className="bi bi-folder-plus me-1" />
                    {loading ? "Creating..." : "Create"}
                </button>
            </div>
        </form>
    );
}
